/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import Swal from 'sweetalert2';
import MDButton from 'components/MDButton';
import MDDatePicker from 'components/MDDatePicker';
import { api } from '../../../api';
import { TEAL, formatDisplayDate, getCurrentUserId } from '../constants';

export default function CreateFollowupFromAppointmentDialog({ appointment, onClose, onDone }) {
  const [probableDate, setProbableDate] = useState(null);
  const [reason, setReason] = useState('');
  const [remarks, setRemarks] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!probableDate) {
      Swal.fire({ icon: 'warning', title: 'Probable date is required' });
      return;
    }
    const confirmResult = await Swal.fire({
      title: 'Create a follow-up?',
      html: `A follow-up will be scheduled for <b>${formatDisplayDate(probableDate)}</b>.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: TEAL,
      confirmButtonText: 'Yes, Create',
      cancelButtonText: 'Cancel',
    });
    if (!confirmResult.isConfirmed) return;

    setSubmitting(true);
    try {
      await api.appointment.createFollowupFromAppointment(appointment.id, {
        probable_date: probableDate,
        irm_users_id: appointment.irm_users_id,
        reason: reason || undefined,
        remarks: remarks || undefined,
        created_by: getCurrentUserId(),
      });
      Swal.fire({ icon: 'success', title: 'Follow-up created', timer: 1800, showConfirmButton: false });
      onDone?.();
    } catch {
      // generic error toast already shown by ApiClient
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Create Follow-Up</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <MDDatePicker label="Probable Date" value={probableDate} onChange={setProbableDate} />
          <TextField
            label="Reason (optional)"
            size="small"
            fullWidth
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
          <TextField
            label="Remarks (optional)"
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={remarks}
            onChange={e => setRemarks(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onClose} color="secondary">Cancel</MDButton>
        <MDButton onClick={handleSubmit} disabled={submitting} variant="gradient" color="logo">
          {submitting ? 'Creating…' : 'Create'}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
